import { motion } from 'motion/react'

type ChipCheckIconProps = {
  active: boolean
}

const ChipCheckIcon = ({ active }: ChipCheckIconProps) => (
  <svg
    aria-hidden
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      animate={{ pathLength: active ? 1 : 0 }}
      d="M6.06 12.73 L10.06 16.73 L16.88 7.8"
      initial={false}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      transition={{ duration: 0.15, ease: 'linear' }}
    />
  </svg>
)

export { ChipCheckIcon }
